import {
  HUB_AP_BILLING_INFO_SUCCESS,
  HUB_ZUORA_FETCH_ZUORA_FAILED,
  HUB_ZUORA_FETCH_ZUORA_SUCCESS,
  HUB_ZUORA_RESET_PARAMS,
} from '../../../../../../actions/actionTypes';
import env from '../../../../../../env';
import { apiFetch } from '../../../../../../services/backendApi';
import { REQ_FETCH_ZUORA_PARAMS } from '../../../../../../services/backendApi/endpointTypes';

type ZuoraPageKeys = 'paymentPage' | 'manageSubscriptionPage';

type GetZuoraConfigReturnType = {
  AU: {
    paymentPage: {
      pageId: string;
      pageUrl: string;
    };
    manageSubscriptionPage: {
      pageId: string;
      pageUrl: string;
    };
  };
  NZ: {
    paymentPage: {
      pageId: string;
      pageUrl: string;
    };
    manageSubscriptionPage: {
      pageId: string;
      pageUrl: string;
    };
  };
};
export function getZuoraConfig(): GetZuoraConfigReturnType {
  const paymentPageConfig = {
    pageIdAU: env.REACT_APP_ZUORA_PAYMENT_PAGE_ID,
    pageUrlAU: env.REACT_APP_ZUORA_PAYMENT_PAGE_URL,
    pageIdNZ: env.REACT_APP_ZUORA_PAYMENT_PAGE_ID_NZ,
    pageUrlNZ: env.REACT_APP_ZUORA_PAYMENT_PAGE_URL_NZ,
  };
  const manageSubscriptionPageConfig = {
    pageIdAU: env.REACT_APP_ZUORA_MANAGE_SUBSCRIPTION_PAGE_ID,
    pageUrlAU: env.REACT_APP_ZUORA_MANAGE_SUBSCRIPTION_PAGE_URL,
    pageIdNZ: env.REACT_APP_ZUORA_MANAGE_SUBSCRIPTION_PAGE_ID_NZ,
    pageUrlNZ: env.REACT_APP_ZUORA_MANAGE_SUBSCRIPTION_PAGE_URL_NZ,
  };
  const params: GetZuoraConfigReturnType = {
    AU: {
      paymentPage: {
        pageId: paymentPageConfig.pageIdAU,
        pageUrl: paymentPageConfig.pageUrlAU,
      },
      manageSubscriptionPage: {
        pageId: manageSubscriptionPageConfig.pageIdAU,
        pageUrl: manageSubscriptionPageConfig.pageUrlAU,
      },
    },
    NZ: {
      paymentPage: {
        pageId: paymentPageConfig.pageIdNZ,
        pageUrl: paymentPageConfig.pageUrlNZ,
      },
      manageSubscriptionPage: {
        pageId: manageSubscriptionPageConfig.pageIdNZ,
        pageUrl: manageSubscriptionPageConfig.pageUrlNZ,
      },
    },
  };

  return params;
}

export function getZuoraConfigByCountry(country: keyof GetZuoraConfigReturnType) {
  const params = getZuoraConfig();
  return params[country];
}

export const fetchZuoraParams = (page: ZuoraPageKeys) => (dispatch, getState) => {
  const country = getState().hubAccountPage.accountDetails.country;
  const zuoraConfig = getZuoraConfigByCountry(country as keyof GetZuoraConfigReturnType);
  if (!zuoraConfig) {
    throw new Error(`Zuora config not found for country: ${country}`);
  }
  const zuoraPageConfig = zuoraConfig[page];
  if (!zuoraPageConfig) {
    throw new Error(`Zuora config not found for page: ${page}`);
  }
  const payload = {
    pageId: zuoraPageConfig?.pageId,
    pageUrl: zuoraPageConfig?.pageUrl,
  };

  return apiFetch(REQ_FETCH_ZUORA_PARAMS, getState(), payload, dispatch)
    .then((data) => {
      const params = {
        id: payload.pageId,
        key: data.key,
        signature: data.signature,
        style: 'inline',
        submitEnabled: true,
        tenantId: data.tenantId,
        token: data.token,
        url: payload.pageUrl,
      };

      dispatch({ type: HUB_ZUORA_FETCH_ZUORA_SUCCESS, payload: params });
    })
    .catch(() => {
      dispatch({ type: HUB_ZUORA_FETCH_ZUORA_FAILED, payload: 'Failed to load payment form, please try again later' });
    });
};

export const resetZuoraParams = () => (dispatch) => {
  dispatch({ type: HUB_ZUORA_RESET_PARAMS });
};

export const setZuoraSuccessMsg = () => (dispatch) => {
  dispatch({
    type: HUB_AP_BILLING_INFO_SUCCESS,
    payload: 'We’re processing your new payment details, they will update shortly.',
  });
};
